export enum OfferPageMode {
  New = 'new',
  Associate = 'associate',
  Edit = 'edit',
  Clone = 'clone',
  Amend = 'amend',
  View = 'view',
}
